import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {FilterModel} from './filter.model';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-regisafe-extended-search',
    templateUrl: './regisafe-extended-search.component.html',
    styleUrls: ['./regisafe-extended-search.component.scss'],
})
export class RegisafeExtendedSearchComponent implements OnInit {
    
    @Input() structure: string;
    @Output() updateFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() filter: EventEmitter<any> = new EventEmitter<any>();
    
    myExtendedFilterForm = this.formBuilder.group(this.assignFormFields());
    filterChanged: Subject<string> = new Subject<string>();
    
    filterFormSitzungsverwaltung: FormGroup;
    filterDataSitzungsverwaltung: any = {
        formFields: [
            {
                type: 'Text',
                name: 'searchText',
                label: 'Suchbegriffe',
                value: ''
            }, {
                type: 'Auswahlfeld',
                name: 'searchFields',
                label: 'Umfang',
                multiple: true,
                value: ['Aktenzeichen', 'Hinweise', 'Text'],
                options: [
                    'Aktenzeichen',
                    'BesondBezeichnung',
                    'Hinweise',
                    'Sitzungskennung',
                    'Text'
                ]
            }, {
                type: 'Auswahlfeld',
                name: 'accuracy',
                label: 'Genauigkeit',
                multiple: false,
                value: 'Phonetik',
                options: [
                    'Phonetik',
                    'Exakt'
                ]
            }, {
                type: 'Auswahlfeld',
                name: 'wordpart',
                label: 'Wortbestandteil',
                multiple: false,
                value: 'Phonetik',
                options: [
                    'Phonetik',
                    'Exakt'
                ]
            }, {
                type: 'Auswahlfeld',
                name: 'modus',
                label: 'Suchmodus',
                multiple: false,
                value: 'Alle Wörter',
                options: [
                    'Alle Wörter',
                    'Nur eines der Wörter'
                ]
            }, {
                type: 'Text',
                name: 'Aktenzeichen',
                label: 'Aktenzeichen',
                value: ''
            }, {
                type: 'Text',
                name: 'Sitzungskennung',
                label: 'Sitzungskennung',
                value: ''
            }, {
                type: 'Auswahlfeld',
                name: 'Aktenzeichen_Auswahl',
                label: null,
                multiple: false,
                value: 'Aktenzeichen und alle Untergeordneten',
                options: [
                    'Aktenzeichen und alle Untergeordneten',
                    'Aktenzeichen-Hierarchie',
                    'Angegebens Aktenzeichen'
                ]
            }, {
                type: 'Auswahlfeld',
                name: 'Sitzung_Auswahl',
                label: null,
                multiple: false,
                value: 'Angegebene Sitzung',
                options: [
                    'Angegebene Sitzung'
                ]
            }
        ]
    };
    
    constructor(private formBuilder: FormBuilder,
                private filterModel: FilterModel) {
        
        this.filterChanged
            .pipe(
                debounceTime(200)
            )
            .subscribe((filter: any) => {
                this.updateFilter.emit(this.filterModel.filter);
            });
        
    }
    
    ngOnInit() {
        this.setFilter();
    }
    
    setFilter() {
        const formGroup = {};
        this.filterDataSitzungsverwaltung.formFields.forEach((field) => {
            formGroup[field.name] = new FormControl({});
        });
        
        this.filterFormSitzungsverwaltung = new FormGroup(formGroup);
    
        this.filterDataSitzungsverwaltung.formFields.forEach((field) => {
            this.filterFormSitzungsverwaltung.controls[field.name].setValue(field.value);
        });
    }
    
    onChange(event, origin) {
        this.filterModel.filter[origin][event.target.name] = event.target.value;
        this.filterChanged.next(event);
    }
    
    onCancel(event, structure) {
        event.target.value = null;
        this.filterModel.filter[structure][event.target.name] = '';
    }
    
    resetForm() {
        this.myExtendedFilterForm.reset();
    }
    
    assignFormFields(): object {
        const formFieldsObj = {};
        const filterObj = this.filterModel.filter;
        
        Object.keys(filterObj).forEach((keyF) => {
            Object.keys(filterObj[keyF]).forEach((keyS) => {
                formFieldsObj[keyF + '_' + keyS] = [''];
            });
        });

        return formFieldsObj;
    }
}
